import localDB from "./localDB";

let GLOBAL = require('./globals');

const SaleData = {
    open(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    async getPublic(id) {
        const response = await fetch(`${GLOBAL.BASE_URL}sales-public/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    },
    async deliveryList(search, page) {
        let response = await fetch(`${GLOBAL.BASE_URL}delivery?search=${search}&page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async counterSaleList(search, page) {
        let response = await fetch(`${GLOBAL.BASE_URL}counter-sales?search=${search}&page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    deliveryUpdate(data, type, res) {
        fetch(`${GLOBAL.BASE_URL}delivery/${data.id}?type=${type}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => {
            res(null)
        });
    },
    get(id, res) {
        fetch(`${GLOBAL.BASE_URL}sales/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((errr) => {
            res(null)
        });
    },
    async ordersList(search, page) {
        let response = await fetch(`${GLOBAL.BASE_URL}orders?search=${search}&page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getDay(branch_office) {
        let response = await fetch(`${GLOBAL.BASE_URL}sales-day?branch_office=${branch_office}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getTotalBalance() {
        let response = await fetch(`${GLOBAL.BASE_URL}sales/balances-total`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    cancel(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/cancel/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => {
            res(null)
        });
    },
    client(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/client/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    end(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/${data.order.sale}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    update(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/${data.order.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    discount(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/discount/${data.sale}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    delivery(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/delivery/${data.sale}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    tip(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/tip/${data.sale}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    amount(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/amount/${data.sale}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    notes(data, res) {
        fetch(`${GLOBAL.BASE_URL}sales/notes/${data.sale}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => {
            res(null)
        });
    },
    async sendInvoice(data, res) {
        await fetch(`${GLOBAL.BASE_URL}sales/send-invoice/`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async getSaleInvoice(id, items) {
        let response = await fetch(`${GLOBAL.BASE_URL}sales/invoice/${id}?items=${items}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json()
    },
    async getOrder(id, items) {
        let response = await fetch(`${GLOBAL.BASE_URL}sales/order/${id}?items=${items}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json()
    },
};

export default SaleData;



// WEBPACK FOOTER //
// ./src/data/SaleData.js